/* ============ IKHTILAF MOTION: Horizon-safe ============ */

(() => {
  const SELECTORS = [
    "[data-animate]",

    // Cibles probables Horizon (sections/blocs typiques)
    ".shopify-section :is(h1,h2,h3,p,li,blockquote,.rte,a,button,.button,figure,img,video,.media,.image-with-text,.rich-text,.multicolumn,.card)"
  ];

  function markTargets(root = document) {
    // 1) Si tu as déjà posé data-animate manuellement, on ne touche pas.
    // 2) Sinon on “auto-tag” des éléments visibles bloc-par-bloc dans les sections.
    const sections = root.querySelectorAll(".shopify-section");
    sections.forEach(section => {
      // Si section déjà traitée
      if (section.dataset.ikMotionBound === "1") return;
      section.dataset.ikMotionBound = "1";

      // Cibles internes: on évite d’animer le footer/headers si tu veux.
      const candidates = section.querySelectorAll(
        ":is(.rte p,.rte li,h1,h2,h3,.button,button,a,figure,.media img,.media video, img, video, .card, .multicolumn-card, .image-with-text__media, .image-with-text__content)"
      );

      let idx = 0;
      candidates.forEach(el => {
        if (el.closest("header, .header, footer, .footer")) return;
        if (el.hasAttribute("data-animate")) return;
        // Ignore éléments minuscules (icônes)
        const rect = el.getBoundingClientRect();
        if (rect.width < 40 || rect.height < 20) return;

        // Ajoute animation + delay progressif
        el.setAttribute("data-animate", "up");
        el.setAttribute("data-delay", "1");
        el.style.setProperty("--ik-delay", `${Math.min(idx * 70, 420)}ms`);
        idx += 1;
      });
    });
  }

  function bindObserver() {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const el = entry.target;
        if (entry.isIntersecting) {
          el.classList.add("is-inview");
          // Une fois animé, on peut arrêter d’observer pour perf
          io.unobserve(el);
        }
      });
    }, { root: null, threshold: 0.12, rootMargin: "0px 0px -8% 0px" });

    document.querySelectorAll("[data-animate]").forEach(el => io.observe(el));
    return io;
  }

  function init(root = document) {
    markTargets(root);
    bindObserver();
  }

  // Init initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  // Important: Shopify theme editor + navigation dynamique (Dawn/Horizon-like)
  document.addEventListener("shopify:section:load", (e) => init(e.target));
  document.addEventListener("shopify:section:reorder", () => init(document));
})();
